/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "27af01836b69c6ffdc5f4f6070813a3164b82f73";
